import { render, staticRenderFns } from "./AnimateOblykLogo.vue?vue&type=template&id=164dddd0&scoped=true"
import script from "./AnimateOblykLogo.vue?vue&type=script&lang=js"
export * from "./AnimateOblykLogo.vue?vue&type=script&lang=js"
import style0 from "./AnimateOblykLogo.vue?vue&type=style&index=0&id=164dddd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164dddd0",
  null
  
)

export default component.exports